/**
 * Device / platform detection utilities.
 *
 * Keep these SSR-safe: always guard access to `window`/`navigator`.
 */

/**
 * Detect iOS / iPadOS Safari.
 *
 * Notes:
 * - Classic iOS devices include "iPad|iPhone|iPod" in `navigator.userAgent`.
 * - iPadOS (13+) can present a "Macintosh" UA when using desktop mode.
 *   We distinguish from macOS by checking for touch capability (`maxTouchPoints > 1`).
 */
export function isIOS(): boolean {
  if (typeof navigator === 'undefined') return false;

  const ua = navigator.userAgent || '';
  const platform = (navigator as Navigator & { platform?: string }).platform || '';
  const maxTouchPoints = (navigator as Navigator & { maxTouchPoints?: number }).maxTouchPoints || 0;

  const isClassicIOS = /iPad|iPhone|iPod/.test(ua);
  const isIPadOS = (platform === 'MacIntel' || /Macintosh/.test(ua)) && maxTouchPoints > 1;

  return isClassicIOS || isIPadOS;
}

